import React, { FC } from 'react';
import { PinnedTooltip as PinnedTooltipType, GateDeviationDataPoint } from './types';
import { formatTooltipTime } from './helpers';

interface PinnedTooltipProps {
  tooltip: PinnedTooltipType;
  dataPoint: GateDeviationDataPoint;
  label: string;
  distanceUnit: string;
  onRemove: () => void;
}

/**
 * Displays a pinned tooltip with flight information
 * Shows/hides close button on hover
 */
export const PinnedTooltip: FC<PinnedTooltipProps> = ({
  tooltip,
  dataPoint,
  label,
  distanceUnit,
  onRemove,
}) => (
  <div
    className="pinned-tooltip"
    style={{
      position: 'absolute',
      top: `${tooltip.y}px`,
      left: `${tooltip.x}px`,
      transform: 'translate(-50%, calc(-100% - 10px))',
      backgroundColor: 'rgba(0, 0, 0, 0.8)',
      color: 'white',
      padding: '8px 12px',
      paddingRight: '24px',
      borderRadius: '4px',
      zIndex: 1000,
      pointerEvents: 'auto',
      whiteSpace: 'nowrap',
      fontSize: '12px',
    }}>
    <div>
      <div>Flight: {label}</div>
      <div>
        Altitude: {Math.round(dataPoint.altitude)} {distanceUnit}
      </div>
      <div>Direction: {dataPoint.direction}</div>
      <div>Time: {formatTooltipTime(dataPoint.time)}</div>
    </div>
    <button
      onClick={onRemove}
      style={{
        position: 'absolute',
        top: '4px',
        right: '4px',
        background: 'transparent',
        border: 'none',
        color: 'white',
        cursor: 'pointer',
        padding: '2px 4px',
        fontSize: '14px',
        lineHeight: '1',
        opacity: 0,
        transition: 'opacity 0.2s',
      }}
      className="close-button"
      onMouseEnter={e => {
        e.currentTarget.style.opacity = '1';
      }}
      onMouseLeave={e => {
        e.currentTarget.style.opacity = '0';
      }}>
      ×
    </button>
    <style>{`
        .pinned-tooltip:hover .close-button {
          opacity: 1 !important;
        }
      `}</style>
  </div>
);
